import { memo } from "react";
import LockGlyph from "./LockGlyph";
import styles from "./rolesPermissions.module.css";

const initialsOf = (name) =>
  String(name || "")
    .split(/[-\s]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");

const RoleCard = ({
  roleId,
  name,
  description,
  accentFrom,
  accentTo,
  adminCount,
  permissionCount,
  totalPermissions,
  isLocked,
  badge,
  isSelected,
  hasChanges,
  onSelect,
}) => {
  const fill = totalPermissions > 0 ? Math.min(100, Math.round((permissionCount / totalPermissions) * 100)) : 0;

  return (
    <button
      type="button"
      className={`${styles.roleCard} ${isSelected ? styles.roleCardSelected : ""}`}
      style={{ "--accent-from": accentFrom, "--accent-to": accentTo }}
      onClick={() => onSelect(roleId)}
      aria-pressed={isSelected}
    >
      <div className={styles.roleCardTop}>
        <span className={styles.roleAvatar}>{initialsOf(name)}</span>
        <div className={styles.roleBadges}>
          {badge && <span className={styles.roleBadge}>{badge}</span>}
          {isLocked && (
            <span className={styles.lockBadge} title="دور أساسي — الاسم ثابت">
              <LockGlyph className={styles.lockGlyph} />
            </span>
          )}
          {hasChanges && <span className={styles.changesDot} title="تغييرات غير محفوظة" />}
        </div>
      </div>
      <span className={styles.roleName} dir="ltr">
        {name}
      </span>
      {description && <span className={styles.roleDescription}>{description}</span>}
      <div className={styles.roleStats}>
        <span>
          <strong>{adminCount ?? "—"}</strong> موظف
        </span>
        <span>
          <strong>{permissionCount}</strong> صلاحية
        </span>
      </div>
      <span className={styles.roleMeter}>
        <span className={styles.roleMeterFill} style={{ width: `${fill}%` }} />
      </span>
    </button>
  );
};

export default memo(RoleCard);
